import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { MAP_LOADER } from './core/tokens/maps.tokens';
import { GoogleMapsLoader } from './services/maps/google-maps-loader.service';
import { authTokenInterceptor } from './features/auth/infrastructure/auth-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authTokenInterceptor])),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    // Wiring hexagonal: el puerto de mapas resuelve al adaptador Google JS.
    { provide: MAP_LOADER, useExisting: GoogleMapsLoader },
  ],
};
